const segmentedLoanProducts = require('./segmentedLoanProducts.js');

module.exports = {
    segmentedLoanProducts
};
